import { useTranslation } from '@klv/hooks/useTranslation';
import SelectInput from '@klv/molecules/form-field/select';
import * as CustomZendeskFields from '@klv/organisms/form-account-access/utils/custom-zendesk-fields';

import type { IZendeskSelectInputProps } from '@klv/organisms/form-account-access/types';

export const ZendeskSelectInput = ({
  fieldName,
  backgroundColor = 'light',
  ...props
}: IZendeskSelectInputProps) => {
  const { t } = useTranslation();
  const dropdownField = CustomZendeskFields.dropdownFields[fieldName];

  return (
    <>
      <SelectInput backgroundColor={backgroundColor} {...props}>
        <option value='' disabled hidden>
          {t('organisms_forms_accountAccessForm_form_issue_placeholder')}
        </option>
        {Object.entries(dropdownField.fieldValues).map(([name, fieldValue]) => {
          const value = t(
            `organisms_forms_accountAccessForm_form_issueType_${fieldValue.tag}`,
          );
          return (
            <option key={name} value={name}>
              {value}
            </option>
          );
        })}
      </SelectInput>
    </>
  );
};
